(function($, undefined) {
	
	'use strict';
	var formValidator;
	var openSettingsBtn;
	var closeSettingsBtn;
	var settingsCtn;
	var submitSlideBtn;
	var collegesList;
	var responsiveDetectorSm;
	var responsiveDetectorPh;

	var toggleSliderSettings = function() {
		$('.settings-ctn').slideToggle();
		openSettingsBtn.fadeToggle();
	};

	var manageSlide = function() {
		var form = $(this).closest('.slide-form');
		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			$('.settings-ctn').find('button, .btn').addClass('disabled');
			form.submit();
		}
	};

	var initSlider = function() {
		$('.home-slider-ctn:not(.no-slides)').slick({
			autoplay: true,
			dots: false,
			arrows: true,
			prevArrow: '.arrow-icon-ctn.previous',
			nextArrow: '.arrow-icon-ctn.next',
			slide: '.home-one-slide',
			pauseOnHover: false,
			autoplaySpeed: 5000,
			draggable: false
		});
	};

	var adjustCollegesCtnHeight = function() {
		var height = 0;
		collegesList.removeAttr('style');

		if (responsiveDetectorPh.css('visibility') !== 'visible') {
			collegesList.find('.college-item').each(function() {
				height += $(this).outerHeight();
			});

			if (responsiveDetectorSm.css('visibility') !== 'visible') {
				collegesList.height(((height / 3) + 20) + 'px');
			} else {
				collegesList.height(((height / 2) + 20) + 'px');
			}
		}
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		openSettingsBtn = $('.open-settings-btn');
		closeSettingsBtn = $('.close-settings-btn');
		settingsCtn = $('.settings-ctn');
		submitSlideBtn = $('.submit-slide-btn');
		collegesList = $('.colleges-list-inner-ctn:not(.admin-logged)');
		responsiveDetectorSm = $('.responsive-detector-sm');
		responsiveDetectorPh = $('.responsive-detector-ph');

		openSettingsBtn.click(toggleSliderSettings);
		closeSettingsBtn.click(toggleSliderSettings);
		submitSlideBtn.click(manageSlide);

		initSlider();
		adjustCollegesCtnHeight();

		$(window).resize(function() {
			adjustCollegesCtnHeight();
		});
	};
	
	$(window).on('load', function () {
		init();
	});
	
})(jQuery);
